export default baseType => ({
  [baseType]: baseType,
  [`FULFILLED_${baseType}`]: `FULFILLED_${baseType}`,
  [`REJECTED_${baseType}`]: `REJECTED_${baseType}`,
  [`CLEAR_${baseType}`]: `CLEAR_${baseType}`
})
